import { RootState } from '../../../store';

export const selectAdjustments = (state: RootState) => state.adjustments;

export const selectAdjustmentsArticles = (state: RootState) => state.adjustments.articles;
export const selectAdjustmentsSelectedArticles = (state: RootState) => state.adjustments.selectedArticles;
export const selectAdjustmentsFilters = (state: RootState) => state.adjustments.filters;
export const selectAdjustmentsPagination = (state: RootState) => state.adjustments.pagination;
export const selectAdjustmentsLoading = (state: RootState) => state.adjustments.loading;
export const selectAdjustmentsError = (state: RootState) => state.adjustments.error;
export const selectAdjustmentReasons = (state: RootState) => state.adjustments.adjustmentReasons;
export const selectProviders = (state: RootState) => state.adjustments.providers;
export const selectLastAdjustmentResult = (state: RootState) => state.adjustments.lastAdjustmentResult;

export const selectSelectedArticlesData = (state: RootState) => {
  const { articles, selectedArticles } = state.adjustments || {} as any;
  const list = Array.isArray(articles) ? articles : [];
  const selected = Array.isArray(selectedArticles) ? selectedArticles : [];
  return list.filter(article => selected.includes(article.id));
};

export const selectIsArticleSelected = (articleId: number) => (state: RootState) => {
  const selected = state.adjustments?.selectedArticles;
  return Array.isArray(selected) ? selected.includes(articleId) : false;
};
